<div class="auth-wrapper auth-v2">
    <div class="auth-inner row m-0">

        <!-- Left Text-->
        <div class="d-none d-md-flex d-lg-flex col-md-7 col-lg-8 align-items-center justify-content-center">
            <div class="w-100 h-auto d-lg-flex d-md-flex align-items-center justify-content-center flex-column">
                <img class="position-fixed zindex-minus-1"
                     [src]="'assets/images/pages/img_login.jpeg'"
                     alt="Login V2"/>
            </div>
        </div>
        <!-- Left Text End -->

        <!-- Login -->
        <div class="d-flex col-md-5 col-lg-4 align-items-center auth-bg">
            <div class="col-12 col-sm-10 col-md-12 col-lg-12 mx-auto">
                <div>
                    <a class="" target="_blank" href="">
                        <img width="80" height="80" src="assets/images/pages/img_login.jpeg" alt="">
                    </a>
                </div>

                <p class="card-text text-left text-primary font-weight-bold">Iniciar Sesión | Bienvenido a Promoscp</p>

                <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                    <div class="alert-body">
                        <p>{{ error }}</p>
                    </div>
                </ngb-alert>
                <form class="auth-login-form mt-2" [formGroup]="_loginForm" (ngSubmit)="onLogin()">
                    <div class="form-group">
                        <label class="form-label" for="email">Correo Electrónico</label>
                        <input type="text"
                               formControlName="email"
                               id="email"
                               class="form-control"
                               [ngClass]="{ 'is-invalid error': _submitted && controls.email.errors }"
                               placeholder="email@promoscp.com"
                               aria-describedby="login-email"
                               autofocus=""
                               tabindex="1"/>
                        <div *ngIf="_submitted && controls.email.errors" class="invalid-feedback">
                            <div *ngIf="controls.email.errors.required">
                                Correo Electrónico es requerido
                            </div>
                            <div *ngIf="controls.email.errors.email">
                                El correo debe ser una dirección de correo electrónico válida
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="d-flex justify-content-between">
                            <label for="password">Contraseña</label>
                        </div>
                        <div class="input-group input-group-merge form-password-toggle">
                            <input [type]="_passwordTextType ? 'text' : 'password'"
                                   formControlName="password"
                                   id="password"
                                   class="form-control form-control-merge"
                                   [ngClass]="{ 'is-invalid error': _submitted && controls.password.errors }"
                                   placeholder="············"
                                   aria-describedby="login-password"
                                   tabindex="2"/>
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                    <i class="feather font-small-4"
                                       [ngClass]="{ 'icon-eye-off': _passwordTextType, 'icon-eye': !_passwordTextType}"
                                       (click)="togglePasswordTextType()">
                                    </i>
                                </span>
                            </div>
                        </div>
                        <div *ngIf="_submitted && controls.password.errors"
                             class="invalid-feedback"
                             [ngClass]="{ 'd-block': _submitted && controls.password.errors }">
                            <div *ngIf="controls.password.errors.required">
                                Contraseña es requerida
                            </div>
                            <div *ngIf="controls.password.errors.minlength">
                                La contraseña debe tener al
                                menos {{ controls.password.errors.minlength.requiredLength }} caracteres
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" id="remember-me" type="checkbox" tabindex="3"/>
                            <label class="custom-control-label" for="remember-me">Recordar contraseña</label>
                        </div>
                    </div>
                    <button [disabled]="_loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
                        <span *ngIf="_loading" class="spinner-border spinner-border-sm mr-1"></span>
                        Ingresar
                    </button>
                </form>
            </div>
        </div>
        <!-- Login End-->
    </div>
</div>
